import React, { useContext, useState } from "react";
import "./singleParent.scss";

import { Close } from "@mui/icons-material";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import "react-phone-input-2/lib/style.css";
// import imageAvatar from "../../../assets/images/studentpp.png";
import { ParentType } from "../../../types/GlobalType";
import { parentContext } from "../../../context/AppContext";

interface Props {
  setOpen: React.Dispatch<React.SetStateAction<Boolean>>;
}
const SingleParent = (props: Props) => {
  const navigate = useNavigate();

  const handleNavidate1 = () => {
    navigate("");
  };
  const handleNavidate2 = () => {
    navigate("parcours-info");
  };

  const location = useLocation();
  let currentRoute: string = location.pathname.split("/")[2];

  const parentData: ParentType = useContext(parentContext);

  // console.log(parentData);

  React.useEffect(() => {
    navigate("");
  }, []);

  return (
    <div className="ProfilPersonnel">
      <div className="dialog">
        <div className="headerUpdate">
          <div className="titleUpdate">
            <div className="left_">
              <span>Profile Parent </span>
            </div>
            <div className="right_">
              <Close className="ico" onClick={() => props.setOpen(false)} />
            </div>
          </div>
        </div>

        <div className="body">
          <div className="avatar_info">
            <div className="img_container">
              <img
                src={
                  "https://cdn.pixabay.com/photo/2017/01/10/03/54/avatar-1968236_1280.png"
                }
                alt=""
              />
              <div className="names">
                <h3>{`${parentData.nom?.toUpperCase()} ${parentData.postnom?.toUpperCase()} ${parentData.prenom?.toUpperCase()}`}</h3>
                <span>
                  {`Ville: ${parentData.ville?.toUpperCase()}, Quartier: ${parentData.quartier?.toUpperCase()}, Téléphone: ${
                    parentData.telephone
                  }`}
                </span>
              </div>
            </div>
            <div className="btns">
              {parentData.parent_status ? (
                <button>Actif</button>
              ) : (
                <button>Non actif</button>
              )}
            </div>
          </div>
          <div className="links">
            <span onClick={handleNavidate1}>
              Appercu
              <div
                className={currentRoute === undefined ? "underline1" : ""}
              ></div>
            </span>

            <span onClick={handleNavidate2}>
              Contact
              <div
                className={currentRoute === "parcours-info" ? "underline2" : ""}
              ></div>
            </span>
          </div>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default SingleParent;
